import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SidebarService } from '../../core/sidebar/sidebar.service';
import { Subscription } from 'rxjs';
import { IdentityService, IdentityUser } from '../../core/security';

/**
 * Componente para renderizar el encabezado de la aplicación
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  /**
   * Entidad del usuario en el sistema
   */
  @Input()
  user?: IdentityUser = undefined;

  /**
   * Indica si el menú esta visible o no
   */
  menuActive = false;

  /**
   * Indica si el menú de usuario esta visiable o no
   */
  userMenuActive = false;

  /**
   * Subscription para obtener el estado del sidebar
   */
  private sidebarSuscription?: Subscription = undefined;

  /**
   * Constructor de la clase
   *
   * @param securityService servicio de seguridad
   * @param identityService servicio de identidad
   */
  constructor(
    private sidebarService: SidebarService,
    private identityService: IdentityService
  ) {}

  /**
   * Inicialización, se carga el estado del sidebar y el usuario
   */
  ngOnInit(): void {
    this.sidebarSuscription = this.sidebarService.onStatusChanged(
      (status: any) => (this.menuActive = status)
    );
  }

  /**
   * Se libera recursos
   */
  ngOnDestroy(): void {
    if (this.sidebarSuscription) {
      this.sidebarSuscription.unsubscribe();
    }
  }

  /**
   * Cambia el estado del sidebar, para que se muestre u oculte.
   */
  changeSidebarStatus(): void {
    this.menuActive = !this.menuActive;
    this.sidebarService.setStatus(this.menuActive);
  }

  /**
   * cierra la sesion del usuario
   */
  logout(): void {
    this.userMenuActive = false;
    this.identityService.fullLogout();
  }
}
